import { call, put } from "redux-saga/effects";
import { takeLatest, takeEvery } from "redux-saga/effects";

import { getBookingsForResourceWithinDatesApi } from "./appointmentStep";
import {
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION
} from "../appointmentAdvancedStep";
/***** SAGA START ******/

function* loadBookingsForResourceWithinDatesForClashSection(payload) {
  //this function loads the customers list into redux

  try {
    const data = yield call(getBookingsForResourceWithinDatesApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      data.bookingId = payload.data.bookingId;
      data.newlySelectedDate = payload.data.newlySelectedDate;
      data.indexOfClash = payload.data.indexOfClash;
      yield put({
        type: GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
        data
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
function* loadBookingsForResourceWithinDatesFoSpecificRecurringSpection(
  payload
) {
  //this function loads the customers list into redux

  try {
    const data = yield call(getBookingsForResourceWithinDatesApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      data.newlySelectedDate = payload.data.newlySelectedDate;
      yield put({
        type: GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION,
        data
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeEvery(
      GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
      loadBookingsForResourceWithinDatesForClashSection
    ),
    takeEvery(
      GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION,
      loadBookingsForResourceWithinDatesFoSpecificRecurringSpection
    )
  ];
}

export default [watchRequests];
